import CustomDatePicker from '@/commons/CustomDatePicker';
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  RadioGroup,
  Select,
  Switch,
} from '@mui/material';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { CustomCard, CustomRadio, CustomTextField } from '../common/CustomMui';
import Dest from './dest';

import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { centerListAtom, defaultOptionAtom } from '@/interfaces/plan/manage';
import dayjs, { Dayjs } from 'dayjs';
import {
  planDestListAtom,
  planRegistConfirmAtom,
  selectedCenterAtom,
  selectedPlanCarListAtom,
} from '@/commons/constants';

import ConfirmModal, { ConfirmModalProps } from './ConfirmModal';
import * as _ from 'lodash';
import Car from './car';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .row{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
  }
`;

export default function InputForm() {
  const [shippingName, setShippingName] = useState<string>(dayjs().add(1, 'day').format('YYYY/MM/DD') + ' 배차 1');
  const [deliveryDate, setDeliveryDate] = useState<string>(dayjs().add(1, 'day').format('YYYY/MM/DD'));

  const [option, setOption] = useState<number>();
  const [optionString, setOptionString] = useState<string>('OPT');

  const [subRegion, setSubRegion] = useState<boolean>(true);

  const [level, setLevel] = useState<number>(2);

  const [registParam, setRegistParam] = useState<ConfirmModalProps>();
  const setPlanRegistConfirmModal = useSetAtom(planRegistConfirmAtom);

  // const { data: defaultOption } = useAtomValue(defaultOptionAtom);

  const { data: centerList } = useAtomValue(centerListAtom);
  const [selectedCenter, setSelectedCenter] = useAtom(selectedCenterAtom);

  const selectedPlanDestList = useAtomValue(planDestListAtom);
  const selectedPlanCarList = useAtomValue(selectedPlanCarListAtom);

  // useEffect(() => {
  //   if (defaultOption) {
  //     setOption(defaultOption.shipping_opt.shipping_type);
  //   }
  // }, [defaultOption]);

  const handleDatePickerChange = (value: Dayjs) => {
    setDeliveryDate(value?.format('YYYY-MM-DD'));
  };

  const handleRadioChange = (e: any, v: any) => {
    setOptionLevel(v, subRegion, level);
    setOptionString(v);
  };

  const handleRadioLevelChange = (e: any, v: any) => {
    setOptionLevel(optionString, subRegion, Number(v));
  };

  const handleSwitchChange = (e: any, v: any) => {
    setOptionLevel(optionString, v, level);
    setSubRegion(v);
  };

  const setOptionLevel = (option: string, subRegion: boolean, level: number) => {
    if (option === 'OPT') {
      setOption(subRegion ? 2 : 0);
    } else {
      setOption(subRegion ? 1 : 3);
    }
    setLevel(level);
  };

  const handleSubmitClick = async () => {
    if (!shippingName || shippingName === '' || shippingName === null) {
      alert('이름을 입력해주세요');
      return;
    }
    if (!deliveryDate || deliveryDate === '' || deliveryDate === null) {
      alert('배송일을 입력해주세요');
      return;
    }
    if (_.find(selectedPlanDestList, ['lat', null])) {
      alert('위치가 확인되지 않은 배송지가 포함되어있습니다.');
      return;
    }
    setRegistParam({
      name: shippingName,
      date: deliveryDate,
      center_seq: selectedCenter,
      center_name: _.find(centerList, ['seq', selectedCenter]).name,
      option: { shipping_type: option, level: level },
      dest_list: selectedPlanDestList,
      car_list: selectedPlanCarList,
    });
    setPlanRegistConfirmModal(true);
  };

  useEffect(() => {
    setOptionLevel(optionString, subRegion, level);
  }, []);

  return (
    <MainWrap>
      <div className="row">
        {centerList && (
          <FormControl sx={{ width: '15rem' }}>
            <InputLabel id="demo-simple-select-label">센터</InputLabel>
            <Select label="센터" value={selectedCenter} onChange={(e) => setSelectedCenter(Number(e.target.value))}>
              {centerList.map((item: any, index: number) => (
                <MenuItem key={index} value={item.seq}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <CustomTextField
          id="outlined-basic"
          label="이름"
          variant="outlined"
          value={shippingName}
          sx={{ width: '28rem' }}
          onChange={(e) => setShippingName(e.target.value)}
        />
        <div style={{ width: '16rem' }}>
          <CustomDatePicker label="배송일" onChange={handleDatePickerChange} defaultValue={dayjs().add(1, 'day')} />
        </div>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            size="large"
            disabled={selectedPlanDestList.length === 0 || selectedPlanCarList.length === 0}
            onClick={handleSubmitClick}
          >
            배차실행
          </Button>
        </div>
      </div>
      <div className="row">
        <CustomCard title={'배차옵션'}>
          <>
            <RadioGroup row defaultValue={optionString} onChange={handleRadioChange}>
              {/* <FormControlLabel value={2} control={<CustomRadio />} label="최소시간" />
            <FormControlLabel value={0} control={<CustomRadio />} label="최대" /> */}
              <FormControlLabel value={'OPT'} control={<CustomRadio />} label="최소차량" />
              <FormControlLabel value={'ALL'} control={<CustomRadio />} label="모든차량" />
              {/* <FormControlLabel value={2} control={<CustomRadio />} label="행정구역 우선 최소차량" />
            <FormControlLabel value={1} control={<CustomRadio />} label="행정구역 우선 모든차량" /> */}
            </RadioGroup>
          </>
        </CustomCard>
        <CustomCard title={'행정구역'}>
          <div style={{ display: 'flex' }}>
            <Switch defaultChecked={true} onChange={handleSwitchChange} />
            <RadioGroup row value={level} defaultValue={1} onChange={handleRadioLevelChange}>
              <FormControlLabel value={1} control={<CustomRadio disabled={!subRegion} />} label="시/도" />
              <FormControlLabel value={2} control={<CustomRadio disabled={!subRegion} />} label="구/군" />
            </RadioGroup>
          </div>
        </CustomCard>
      </div>
      <div className="row" style={{ flexGrow: 1, overflow: 'hidden' }}>
        <Dest />
        <Car />
      </div>
      <ConfirmModal target={registParam} />
    </MainWrap>
  );
}
